// ============================================================
// App.js — Composant racine de l'application AVALIST
// Responsabilités :
//   1. Fetch centralisé de tous les parcs depuis l'API (/database)
//   2. Barre de navigation (filtres de statut, bouton ajout, déconnexion)
//   3. Distribution des données (clients, filtres) aux composants enfants :
//      - UserList (calls.js) : colonne liste à gauche
//      - MyMap (MapApp.js)   : carte Google Maps à droite
//   4. Modale d'ajout d'un nouveau parc (FormPark)
// Props :
//   auth0token — token Bearer Auth0 (Promise)
//   user       — objet utilisateur Auth0 (non utilisé directement dans le rendu)
// ============================================================

import React from 'react';
import MyMap from './MapApp';
import UserList from './calls'
import './App.css';
import { Row, Col, Navbar, Nav, NavLink, Button, Modal, Form, Alert, Spinner } from 'react-bootstrap';
import { Plus, GearFill, PersonPlus, PeopleFill, Trash3Fill } from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Component } from 'react';
import FormPark from './addform'
import LogOut from './logout'
import { FILTER_DONE, FILTER_NEEDED, FILTER_URGENT, FILTER_ALL, FILTER_STANDBY } from './constants';
import axios from 'axios';

const ROLE_STYLES = {
  'super-admin' : { backgroundColor: '#f59e0b', color: '#1a1a1a', label: 'Super Admin' },
  'admin'       : { backgroundColor: '#60a5fa', color: '#1a1a1a', label: 'Admin'       },
  'user'        : { backgroundColor: 'rgba(255,255,255,0.15)', color: 'white', label: 'Utilisateur' },
};

function RoleBadge({ role }) {
  if (!role) return null;
  const style = ROLE_STYLES[role] || { backgroundColor: 'rgba(255,255,255,0.15)', color: 'white', label: role };
  return (
    <span style={{
      backgroundColor : style.backgroundColor,
      color           : style.color,
      fontWeight      : 600,
      fontSize        : '0.78rem',
      padding         : '4px 10px',
      borderRadius    : '20px',
      marginLeft      : '16px',
      letterSpacing   : '0.03em',
      whiteSpace      : 'nowrap',
    }}>
      {style.label}
    </span>
  );
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterClient: '',        // Texte de recherche par nom de parc
      filterControl: null,     // Filtre de statut (null = tous, voir FILTER_*)
      filterUserControl: null, // Filtre par expert (null = tous)
      clients: [],             // Liste complète des parcs (source unique de vérité)
      experts: [],             // Liste des experts (depuis /experts)
      newExpertName: '',       // Champ nom pour l'ajout d'expert
      newExpertEmail: '',      // Champ email pour l'ajout d'expert
      expertError: '',         // Message d'erreur ajout expert
      expertSuccess: null,     // { emailSent, inviteLink } après ajout réussi
      expertSubmitting: false,  // Garde anti double-soumission
      newExpertAsAdmin: false,  // Checkbox "ajouter en tant qu'administrateur"
isUserManageOpen: false,  // Modale gestion comptes Auth0
      auth0Users: [],           // Liste des utilisateurs Auth0
      auth0UsersLoading: false, // Chargement en cours
      userToDelete: null,       // Compte Auth0 en attente de confirmation de suppression
    };
  }

  // Au montage : charge immédiatement la liste des parcs et des experts
  componentDidMount() {
    this.UserList();
    this.loadExperts();
  }

  // Fetch de la liste des experts depuis /experts
  loadExperts() {
    Promise.resolve(this.props.auth0token).then((token) => {
      axios.get('/experts', { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => { this.setState({ experts: res.data }); })
        .catch((err) => { console.error('GET /experts failed', err); });
    });
  }

  // Fetch de tous les parcs via POST /database (auth obligatoire).
  // Met à jour this.state.clients, distribué ensuite aux deux enfants.
  // Appelé au montage ET après chaque mutation (onRefresh).
  UserList() {
    Promise.resolve(this.props.auth0token).then((token) => {
      axios.post('/database', {}, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((results) => { this.setState({ clients: results.data }); })
      .catch((err) => { console.error('POST /database failed', err); });
    });
  }

  // Génère un lien d'invitation temporaire (48h) et le copie dans le presse-papier
  // Ajoute un expert ET envoie automatiquement un lien d'invitation par email
  addExpertAndInvite = () => {
    if (this.state.expertSubmitting) return;
    var name = this.state.newExpertName.trim();
    var email = this.state.newExpertEmail.trim();
    if (!name || !email) {
      this.setState({ expertError: 'Nom et email requis' });
      return;
    }
    this.setState({ expertSubmitting: true, expertError: '', expertSuccess: null });
    Promise.resolve(this.props.auth0token).then((token) => {
      axios.post('/experts/invite', { name: name, email: email, asAdmin: this.state.newExpertAsAdmin }, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          this.setState({ newExpertName: '', newExpertEmail: '', newExpertAsAdmin: false, expertSubmitting: false, expertSuccess: { emailSent: res.data.emailSent, inviteLink: res.data.inviteLink } });
          this.loadExperts();
        })
        .catch((err) => { this.setState({ expertSubmitting: false, expertError: 'Erreur : ' + ((err.response && err.response.data && err.response.data.error) || err.message), expertSuccess: null }); });
    });
  }

  // Ouvre/ferme la modale d'ajout d'un nouveau parc
  openModal = () => this.setState({ isOpen: true});
  closeModal = () => this.setState({ isOpen: false});

  // Ouvre/ferme la modale du menu administrateur
  openAdminModal  = () => this.setState({ isAdminOpen: true });
  closeAdminModal = () => this.setState({ isAdminOpen: false });

// Ouvre la modale de gestion des utilisateurs Auth0 et charge la liste
  openUserManageModal = () => {
    this.setState({ isAdminOpen: false, isUserManageOpen: true, auth0UsersLoading: true, auth0Users: [] });
    this.loadAuth0Users();
  }
  closeUserManageModal = () => this.setState({ isUserManageOpen: false, isAdminOpen: true, auth0Users: [], userToDelete: null });

  // Charge la liste des utilisateurs Auth0 depuis GET /users
  loadAuth0Users = () => {
    Promise.resolve(this.props.auth0token).then((token) => {
      axios.get('/users', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => { this.setState({ auth0Users: res.data, auth0UsersLoading: false }); })
        .catch((err) => { this.setState({ auth0UsersLoading: false, expertError: 'Erreur chargement utilisateurs : ' + err.message }); });
    });
  }

  // Supprime un compte Auth0 puis recharge la liste
  deleteAuth0User = () => {
    var user = this.state.userToDelete;
    if (!user) return;
    Promise.resolve(this.props.auth0token).then((token) => {
      axios.delete('/users/' + encodeURIComponent(user.userId), { headers: { Authorization: 'Bearer ' + token } })
        .then(() => {
          this.setState({ userToDelete: null });
          this.loadAuth0Users();
        })
        .catch((err) => {
          this.setState({ userToDelete: null, expertError: 'Erreur : ' + ((err.response && err.response.data && err.response.data.error) || err.message) });
        });
    });
  }

// Met à jour le filtre de recherche textuelle dans le state
  handleChange(e) {
    let fleldVal = e.target.value;
    this.setState({filterClient: fleldVal})
  }

  render() {
    return (
      <div>
        {/* === BARRE DE NAVIGATION === */}
        {/* sticky="top" : reste visible pendant le scroll de la liste */}
        <Navbar collapseOnSelect expand="lg" variant="dark" style={{ backgroundColor: '#1a5c38' }} sticky="top">

          {/* Logo/Marque : réinitialise tous les filtres au clic */}
          <Navbar.Brand onClick={() => this.setState({filterControl: FILTER_ALL, filterUserControl: null, filterClient: []})} href="#home">AVALIST</Navbar.Brand>

          {/* Bouton hamburger affiché sous le breakpoint lg (< 992px) */}
          <Navbar.Toggle aria-controls="responsive-navbar-nav"/>

          <Navbar.Collapse id="responsive-navbar-nav">
            {/* Liens de filtres de statut + bouton "Ajouter un Parc" — alignés à gauche */}
            <Nav className="mr-auto navbar-nav-main" style={{ alignItems: "center" }}>
              {/* Génère dynamiquement les 4 liens de filtre depuis le tableau */}
              {[
                { label: 'Contrôle effectué',   filter: FILTER_DONE },
                { label: 'Contrôle nécessaire', filter: FILTER_NEEDED },
                { label: 'Contrôle urgent',     filter: FILTER_URGENT },
                { label: 'Parcs en Standby',    filter: FILTER_STANDBY },
              ].map(({ label, filter }) => (
                // Lien actif = gras + souligné ; inactif = normal
                <NavLink key={filter} style={{ marginLeft: "15px", color: "white", fontWeight: this.state.filterControl === filter ? 'bold' : 'normal', textDecoration: this.state.filterControl === filter ? 'underline' : 'none', textUnderlineOffset: '4px' }} onClick={() => this.setState({ filterControl: filter })}>{label}</NavLink>
              ))}

              {/* Badge rôle utilisateur + bouton ajout */}
              <RoleBadge role={this.props.role} />
              <Button lg={2} md={3} sm={2} className="navbar-add-btn" style={{ marginLeft: "16px", backgroundColor: "#2d8a4e", borderColor: "#2d8a4e", color: "white", padding: "6px 14px", whiteSpace: "nowrap", fontSize: "0.95rem", display: "inline-flex", alignItems: "center", gap: "4px" }} onClick={() => this.openModal()}>Ajouter un Parc <Plus size={18} strokeWidth={2.5} /></Button>

              {/* Bouton menu administrateur — visible uniquement pour admin et super-admin */}
              {(this.props.role === 'admin' || this.props.role === 'super-admin') && (
                <Button className="navbar-add-btn" style={{ marginLeft: "10px", backgroundColor: "#1a3a5c", borderColor: "#1a3a5c", color: "white", padding: "6px 14px", whiteSpace: "nowrap", fontSize: "0.95rem", display: "inline-flex", alignItems: "center", gap: "6px" }} onClick={() => this.openAdminModal()}>
                  <GearFill size={15} /> Menu administrateur
                </Button>
              )}
            </Nav>

            {/* Bouton de déconnexion — aligné à droite */}
            <Nav className="ml-auto">
              <LogOut onLogout={this.props.onLogout}/>
            </Nav>
          </Navbar.Collapse>
          {/* La barre de recherche a été déplacée dans le composant UserList */}
        </Navbar>

        {/* === ZONE PRINCIPALE : LISTE + CARTE === */}
        {/* noGutters + margin:0 supprime les gouttières Bootstrap */}
        <Row noGutters style={{ margin: 0 }}>
          {/* Colonne liste : UserList gère elle-même ses breakpoints (xs=12, md=6, lg=6, xl=3) */}
          <UserList
            filterClient={this.state.filterClient}
            filterControl={this.state.filterControl}
            filterUserControl={this.state.filterUserControl}
            authtoken={this.props.auth0token}
            clients={this.state.clients}
            experts={this.state.experts}
            onRefresh={this.UserList.bind(this)}
            onFilterChange={this.handleChange.bind(this)}
            onFilterUserControlChange={(val) => this.setState({filterUserControl: val})}
            role={this.props.role}
            userEmail={this.props.userEmail}
          />

          {/* Colonne carte : masquée sur mobile (d-none d-md-block) */}
          <Col md={6} lg={6} xl={9} className="map d-none d-md-block">
            <MyMap
              filterClient={this.state.filterClient}
              filterControl={this.state.filterControl}
              filterUserControl={this.state.filterUserControl}
              authtoken={this.props.auth0token}
              clients={this.state.clients}
              experts={this.state.experts}
              onRefresh={this.UserList.bind(this)}
              role={this.props.role}
              userEmail={this.props.userEmail}
              role={this.props.role}
              userEmail={this.props.userEmail}
            />
          </Col>
        </Row>

        {/* === MODALE MENU ADMINISTRATEUR === */}
        <Modal show={this.state.isAdminOpen} onHide={this.closeAdminModal}>
          <Modal.Header closeButton>
            <Modal.Title><GearFill style={{ marginRight: '8px' }} />Menu administrateur</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6 style={{ fontWeight: 600, marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}><PersonPlus size={18} /> Ajouter un expert</h6>
            <p style={{ fontSize: '0.83rem', color: '#666', marginBottom: '14px' }}>Un email d'invitation sera automatiquement envoyé à l'adresse renseignée.</p>

            {this.state.expertError && <Alert variant="danger" style={{ fontSize: '0.9rem' }}>{this.state.expertError}</Alert>}

            {this.state.expertSuccess && (
              <Alert variant="success" style={{ fontSize: '0.88rem' }}>
                {this.state.expertSuccess.emailSent
                  ? 'Expert ajouté et invitation envoyée par email.'
                  : 'Expert ajouté. Email non envoyé (SMTP non configuré) — lien d\'invitation :'}
                {!this.state.expertSuccess.emailSent && (
                  <div style={{ marginTop: '6px', wordBreak: 'break-all', fontSize: '0.78rem' }}>
                    <a href={this.state.expertSuccess.inviteLink} target="_blank" rel="noopener noreferrer">{this.state.expertSuccess.inviteLink}</a>
                  </div>
                )}
              </Alert>
            )}

            <Form onSubmit={(e) => { e.preventDefault(); this.addExpertAndInvite(); }}>
              <Form.Group style={{ marginBottom: '10px' }}>
                <Form.Label style={{ fontSize: '0.9rem' }}>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ex: Martin"
                  value={this.state.newExpertName}
                  onChange={(e) => this.setState({ newExpertName: e.target.value, expertSuccess: null })}
                  required
                />
              </Form.Group>
              <Form.Group style={{ marginBottom: '14px' }}>
                <Form.Label style={{ fontSize: '0.9rem' }}>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="prenom@exemple.fr"
                  value={this.state.newExpertEmail}
                  onChange={(e) => this.setState({ newExpertEmail: e.target.value, expertSuccess: null })}
                  required
                />
              </Form.Group>
              {this.props.role === 'super-admin' && (
                <Form.Group style={{ marginBottom: '14px' }}>
                  <Form.Check
                    type="checkbox"
                    id="expert-as-admin"
                    label="Ajouter en tant qu'administrateur"
                    checked={this.state.newExpertAsAdmin}
                    onChange={(e) => this.setState({ newExpertAsAdmin: e.target.checked })}
                    style={{ fontSize: '0.9rem' }}
                  />
                </Form.Group>
              )}
              <Button type="submit" disabled={this.state.expertSubmitting} style={{ backgroundColor: '#2d8a4e', borderColor: '#2d8a4e', color: 'white', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                <PersonPlus size={16} /> {this.state.expertSubmitting ? 'Envoi en cours…' : "Ajouter et envoyer l'invitation"}
              </Button>
            </Form>

            {this.state.experts.length > 0 && (
              <div style={{ marginTop: '22px' }}>
                <h6 style={{ fontWeight: 600, marginBottom: '8px', fontSize: '0.9rem' }}>Experts existants</h6>
                {this.state.experts.map((e) => (
                  <div key={e.id} style={{ padding: '6px 10px', marginBottom: '4px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '0.88rem' }}>
                    <strong>{e.name}</strong> — {e.email}
                  </div>
                ))}
              </div>
            )}

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <Button variant="outline-secondary" size="sm" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }} onClick={this.openUserManageModal}>
                <PeopleFill size={14} /> Gérer les utilisateurs
              </Button>
            </div>
          </Modal.Body>
        </Modal>


        {/* === MODALE GESTION UTILISATEURS AUTH0 === */}
        <Modal show={this.state.isUserManageOpen} onHide={this.closeUserManageModal}>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '1rem' }}><PeopleFill style={{ marginRight: '8px' }} />Gérer les utilisateurs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.expertError && <Alert variant="danger" style={{ fontSize: '0.9rem' }}>{this.state.expertError}</Alert>}
            {this.state.auth0UsersLoading
              ? <div style={{ textAlign: 'center', padding: '20px' }}><Spinner animation="border" size="sm" /> Chargement…</div>
              : this.state.auth0Users.length === 0
                ? <p style={{ color: '#888', fontSize: '0.9rem' }}>Aucun utilisateur trouvé.</p>
                : this.state.auth0Users.map((u) => {
                  var style = ROLE_STYLES[u.role] || ROLE_STYLES['user'];
                  var canDelete = this.props.role === 'super-admin' || (this.props.role === 'admin' && u.role !== 'admin' && u.role !== 'super-admin');
                  return (
                    <div key={u.userId} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 10px', marginBottom: '4px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '0.88rem' }}>
                      <span>
                        <span style={{ backgroundColor: style.backgroundColor, color: style.color === 'white' ? '#333' : style.color, fontSize: '0.74rem', fontWeight: 600, padding: '2px 7px', borderRadius: '10px', marginRight: '8px', border: '1px solid #ccc' }}>{style.label}</span>
                        <strong>{u.name || u.email}</strong>
                        {u.name && u.email !== u.name && <span style={{ color: '#888', marginLeft: '6px' }}>{u.email}</span>}
                      </span>
                      {canDelete && (
                        <Button size="sm" variant="outline-danger" style={{ padding: '2px 8px', display: 'inline-flex', alignItems: 'center', gap: '4px' }} onClick={() => this.setState({ userToDelete: u })}>
                          <Trash3Fill size={13} /> Supprimer
                        </Button>
                      )}
                    </div>
                  );
                })
            }
          </Modal.Body>
        </Modal>

        {/* === MODALE CONFIRMATION SUPPRESSION UTILISATEUR AUTH0 === */}
        <Modal show={!!this.state.userToDelete} onHide={() => this.setState({ userToDelete: null })} size="sm" centered>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '1rem' }}><PeopleFill style={{ marginRight: '8px' }} />Supprimer le compte</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.userToDelete && (
              <p style={{ margin: 0, fontSize: '0.9rem' }}>
                Supprimer le compte de <strong>{this.state.userToDelete.name || this.state.userToDelete.email}</strong> ?<br />
                <span style={{ color: '#c0392b', fontSize: '0.82rem' }}>Cette action est irréversible. L'utilisateur ne pourra plus se connecter.</span>
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={() => this.setState({ userToDelete: null })}>Annuler</Button>
            <Button variant="danger" size="sm" onClick={this.deleteAuth0User} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
              <Trash3Fill size={13} /> Confirmer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* === MODALE D'AJOUT D'UN NOUVEAU PARC === */}
        <Modal show={this.state.isOpen} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Nouveau Client</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* FormPark : reçoit onRefresh pour recharger la liste après ajout */}
            <FormPark authtoken={this.props.auth0token} experts={this.state.experts} onRefresh={this.UserList.bind(this)} onHide={this.closeModal}/>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

export default App;
